// src/shared/components/Loading/index.js
import React, { useMemo } from 'react';
import { Spinner, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles.css';

const Loading = ({ message = 'Loading...', isWarmup = false }) => {
  const warmupMessage = useMemo(() => {
    if (!isWarmup) return null;
    const puns = [
      '🏋️‍♂️ FitOps is syncing reps, please wait…',
      '🤸‍♀️ Stretching the FitOps API, hold your plank…',
      '🔥 FitOps is warming up the servers, keep your heart rate steady.',
      '🏃‍♀️ Loading FitOps data, like a marathon of packets.',
      '🏃‍♀️ FitOps is doing a quick sprint, stay pumped!',
      '🤾‍♂️ Your FitOps backend is doing burpees with code, hang tight.',
      '🛤️ FitOps is calibrating the treadmill of requests.',
      '💪 One moment, FitOps is loading the dumbbells of data.',
      '🧘‍♀️ FitOps is buffering, think of it as a cool‑down stretch.',
      '🔢 FitOps is crunching numbers, literally!'
    ];
    const idx = Math.floor(Math.random() * puns.length);
    return puns[idx];
  }, [isWarmup]);

  const displayMessage = isWarmup ? warmupMessage : message;
  return (
    <Container className="loading-container">
      <Spinner animation="border" role="status" />
      {displayMessage && (
        <span className="loading-message">{displayMessage}</span>
      )}
    </Container>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  isWarmup: PropTypes.bool,
};

export default Loading;
